import { render, staticRenderFns } from "./AppTextareaAi.vue?vue&type=template&id=3582de0e&scoped=true"
import script from "./AppTextareaAi.vue?vue&type=script&lang=js"
export * from "./AppTextareaAi.vue?vue&type=script&lang=js"
import style0 from "./AppTextareaAi.vue?vue&type=style&index=0&id=3582de0e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3582de0e",
  null
  
)

export default component.exports